import { render, staticRenderFns } from "./ParcoursStatus.vue?vue&type=template&id=4c4ce795&scoped=true&"
import script from "./ParcoursStatus.vue?vue&type=script&lang=js&"
export * from "./ParcoursStatus.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursStatus.vue?vue&type=style&index=0&id=4c4ce795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ce795",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
